/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { setMode } from "data/store/reducers/form";
import { useAuth } from "cms/auth/hooks/use-auth";
import { useParams } from "react-router-dom";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { useFormContext } from "./use-form-context";
import { Logger } from "cms/utils/log/logger";
import { useCallback } from "react";
import { dispatch as storeDispatch } from "data/store";
import { setForm } from "data/store/reducers/form-responses";


export function useForm () {
    
    const { formGuid } = useParams();

    const { state, dispatch } = useFormContext();

    const { token } = useAuth();

    // TODO: Change to a thunk
    const createNewSchemaForm = useCallback(async (formType) => {
        const data = {
            type: formType,
            steps: [],
            questions: [],
            // settings: defaultSettings,
        };

        const newForm = await SimpliCityAdminSDK.form.create(token, data);

        if (newForm.guid) {
            storeDispatch(setMode("display"));
            
            // Update Form State
            dispatch({
                type: "form/set",
                form: newForm,
            });
        }

        return newForm;
    }, [token, dispatch]);

    // TODO: Change to a thunk
    const duplicateSchemaForm = useCallback(async (formGuid) => {
        const newForm = await SimpliCityAdminSDK.form.duplicate(token, formGuid);

        if (newForm.guid) {
            storeDispatch(setMode("display"));

            // Update Form State
            dispatch({
                type: "form/set",
                form: newForm,
            });
        }

        return newForm;
    }, [token, dispatch]);

    // TODO: Change to a thunk
    const loadCurrentSchemaForm = useCallback(async (formGuid) => {
        const currentForm = await SimpliCityAdminSDK.form.findOne(token, formGuid);

        if (currentForm) {
            storeDispatch(setMode("display"));
            dispatch({ type: "form/set", form: currentForm });
        }
        storeDispatch(setForm({
            form_guid: formGuid,
            form: currentForm,
        }));
        return currentForm;
    }, [token, dispatch]);

    const deleteSchemaForm = useCallback(async (formGuid) => {
        return SimpliCityAdminSDK.form.delete(token, formGuid);
    }, [token]);

    const updateFormName = useCallback(async (name) => {
        dispatch({ type: "form/dirty", isFormDirty: true });

        // destructure locally for clarity
        const { guid, steps, questions, keywords, settings } = state.form;

        try {
            const res = await SimpliCityAdminSDK.form.update(token, formGuid, {
                questions,
                guid,
                name,
                steps,
                keywords,
                settings,
            });

            if (res) {
                dispatch({ type: "form/set-name", name });
            }

        } catch (error) {
            Logger.error(error);
        } finally {
            dispatch({ type: "form/dirty", isFormDirty: false });
        }
    }, [token, formGuid, state.form, dispatch]);

    return {
        createNewSchemaForm,
        duplicateSchemaForm,
        loadCurrentSchemaForm,
        deleteSchemaForm,
        updateFormName,
    };
}
